export enum ExistingOrNewRoute {
  Existing = 'existing',
  New = 'new',
}
